import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { setRaces } from 'store/marketplace/actions';
import { IMarketPlaceState } from 'store/marketplace/types';
import Strings from 'utils/Strings';
import { characterRaces } from 'constants/filters/Character';
import { CharacterRace } from 'models/Filters';
import FilterCard from 'components/common/filter-card';
import FilterContainer from 'components/common/filter-container';
import Circle from 'components/global/circle';

const Races: React.FunctionComponent = () => {
  const dispatch = useDispatch();
  const { races } = useSelector<RootState, IMarketPlaceState>(state => state.MarketPlace);

  const onSelectHandler = (key: CharacterRace) => {
    const index = races.findIndex(item => item === key);
    if (index === -1) {
      races.push(key);
      dispatch(setRaces(races));
    } else {
      races.splice(index, 1);
      dispatch(setRaces(races));
    }
  };

  return (
    <FilterContainer
      className="mt-3"
      title={Strings.races}
      count={races.length > 0 ? races.length : undefined}
      body={
        <div className="d-flex flex-wrap align-items-center justify-content-between mb-3">
          {characterRaces.map(race => (
            <FilterCard
              key={race.type}
              icon={<Circle color={race.color} />}
              text={race.type}
              onClick={() => onSelectHandler(race.type)}
              active={races.includes(race.type)}
            />
          ))}
        </div>
      }
    />
  );
};
export default Races;
